import { render, staticRenderFns } from "./ConfermaEliminazioneNotifiche.vue?vue&type=template&id=51d0abbf&"
import script from "./ConfermaEliminazioneNotifiche.vue?vue&type=script&lang=js&"
export * from "./ConfermaEliminazioneNotifiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports